$( document ).ready(function() {
	$('.modal-header .close').on('click', function (e) {
		$('.modal').hide();
		console.log('123');
	})
	$('.ico-arrow-back').on('click', function (e) {
		$('.modal').hide();
	})

	$('.open-maximum').on('click', function(e){
		$('.modal-maximum').show();
	})

	$('.open-drive').on('click', function(e){
		$('.modal-drive').show();
	})

	function urlChange() {
		var full_path = location.origin + location.pathname;
		return $("#bread_crumbs_url").attr("href",full_path.split('/').slice(0, -2).join("/"));
	}
	urlChange();
});